module.exports = __webpack_public_path__ + "img/songben.7240ecb0.png";